import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actionCreators } from '../../store/OrderPlannerDelivery';
import './OrderPlannerDelivery.css';
import { Button, DropdownButton, MenuItem, Checkbox } from 'react-bootstrap';
import DatePicker from "react-datepicker";
import ResetOrderPlannerDataButton from '../common/ResetOrderPlannerData';
import { OrderDataReview } from '../common/OrderDataReview';

import "react-datepicker/dist/react-datepicker.css";

var orderItems = [];
var lines = 0;
var subtotal = 0;
var totalQty = 0;
var totalCost = 0;

for (var key in localStorage) {
    if (key.includes('order:')) {
        console.log(localStorage.getItem(key).split(','));

        var itemInfoCsv = key.replace('order:', '');
        lines += 1;
        var qty = Number(localStorage.getItem(key).split(',')[0]);
        totalQty += qty;

        var price = Number(localStorage.getItem(key).split(',')[2]);

        var lclSubtotal = price * qty;
        
        subtotal += lclSubtotal;

        var lclCost = Number(localStorage.getItem(key).split(',')[3]);

        totalCost += lclCost * qty;

        orderItems.push(itemInfoCsv + ';' + localStorage.getItem(key));
    }
}

class OrderPlannerReview extends Component {
    constructor(props) {
        super(props);

        this.handleDateChange = this.handleDateChange.bind(this);
        this.toggleShowDetails = this.toggleShowDetails.bind(this);
        this.toggleShipComplete = this.toggleShipComplete.bind(this);

        this.state = {
            value: localStorage.getItem('orderPO') || '',
            specialInstructions: localStorage.getItem('specialInstructions'),
            uniquePO: this.props.uniquePO === true ? 'Yes' : 'No',
            requirePO: this.props.requirePO === true ? 'Yes' : 'No',
            orderItems: orderItems,
            orderSubtotal: subtotal,
            orderTotalCost: totalCost,
            orderLines: lines,
            orderQty: totalQty,
            showDetails: false,
            showDetailsText: "Show Details...",
            mobileView: window.innerWidth < 768,
            tabletView: window.innerWidth <= 1254 && window.innerWidth >= 768,
            isShipComplete: false,
            isSalesQuote: Boolean(localStorage.getItem('isSalesQuote')) === true ? true : false,
            windowWidth: window.innerWidth
        };
    }

    componentDidMount() {
        window.addEventListener("resize", this.resize.bind(this));
        this.resize(true);
    }

    resize(skip) {
        // We only want to resize if the width changes so the Android 
        // keyboard doesn't disappear on inputs from the vertical height change
        if (window.innerWidth !== this.state.windowWidth || skip === true) {
            this.setState({ mobileView: window.innerWidth < 768 }, this.setState({ tabletView: window.innerWidth <= 1254 && window.innerWidth >= 768 }));
            this.setState({ wideView: window.innerWidth >= 1580 })
            this.setState({ windowWidth: window.innerWidth });
        }
    }

    componentWillMount() {
        // This method runs when the component is first added to the page

        if (!localStorage.getItem('customer')) {
            window.open('/customer-search', '_self');
        } else if (!localStorage.getItem('orderPlannerContact')) {
            // Delivery information
            window.open('/order-planner-contact', '_self');

            return;
        } else if (localStorage.getItem('deliveryModeCode')
            && localStorage.getItem('deliveryModeDescription')
            && localStorage.getItem('badPO') !== "true"
            && localStorage.getItem('badPO') !== true) {

            if (localStorage.getItem('requirePO') === 'true' && !localStorage.getItem('orderPO')) {
                window.open('/order-planner-delivery', '_self');
            }

            var testOrderKey = false;

            for (var key in localStorage) {
                if (key.includes('order:')) {
                    testOrderKey = true;

                    break;
                }
            }

            if (testOrderKey === true) {
                this.props.history.push('/order-planner-review/');

                this.props.queryOrderPlannerDeliveryModes(false);
            } else {
                window.open('/order-planner-products', '_self');

                return;
            }
        } else {
            window.open('/order-planner-delivery', '_self');

            return;
        }        
    }

    componentWillReceiveProps(nextProps) {
        // This method runs when incoming props (e.g., route params) change
        this.setState({ mobileView: window.innerWidth <= 1247 });
    }

    handleDateChange(date) {
        this.props.selectDeliveryDate(date.toISOString().substring(0, 10));
    }

    getValidationStatePO() {
        const length = this.state.value.length;
        //if (length > 10) return 'success';
        //else if (length > 5) return 'warning';
        if (this.props.requirePO && length === 0) return 'error'
        else return 'success';
    }

    getValidationStateSpecialInstructions() {
        //const length = this.state.value.length;
        //if (length > 10) return 'success';
        //else if (length > 5) return 'warning';
        //else if (length > 0) return 'error';
        return null;
    }

    toggleShowDetails() {
        var currentState = this.state.showDetails;
        console.log(currentState);

        if (currentState === true) {
            this.setState({ showDetails: false });
            this.setState({ showDetailsText: "Show Details..." });
        } else {
            this.setState({ showDetails: true });
            this.setState({ showDetailsText: "Hide Details..." });
        }
    }

    toggleShipComplete(e) {
        if (this.state.isShipComplete === true) {
            this.setState({ isShipComplete: false });
            localStorage.removeItem('shipComplete');
        } else {
            localStorage.setItem('shipComplete', true);
            this.setState({ isShipComplete: true });
        }
    }

    onDatepickerRef(el) { if (el && el.input) { el.input.readOnly = true; } }

    render() {
        var date = new Date();
        date = new Date(date.getTime() - (date.getTimezoneOffset() * 60000));
        return (
            <div style={this.state.mobileView === true ? { marginTop: '52px' } : { marginTop: '20px' }}>
                <h1>4. Order Review</h1>
                <h2 style={{ color: 'red' }}>Not Yet Submitted</h2>
                <h2 style={{ color: "orange" }}
                    className={this.state.isSalesQuote === true ? '' : 'hidden'}
                >
                    Quotation
                </h2>
                <p className="op-paragraph">
                    {this.state.isSalesQuote === true ? 'Quote Date' : 'Order Date'}: <b>{date.getFullYear() + '-'
                    + (date.getMonth() + 1).toString().padStart(2, '0') + '-'
                        + date.getDate().toString().padStart(2, '0')}</b>
                </p>

                <p className="op-paragraph" style={{marginBottom: '5px'}}>Delivery Mode:</p>
                <DropdownButton
                    id="DeliveryModeButton"
                    title={this.props.selectedDeliveryMode}
                    style={{ display: 'inline', marginRight: '5px', fontSize: '12px', marginTop: '-5px' }}
                >
                    {this.props.deliveryModes.map(deliveryMode =>
                        <MenuItem
                            key={deliveryMode.Code}
                            onClick={() => {
                                this.props.selectDeliveryMode(deliveryMode);
                            }}
                        >
                            {deliveryMode.Description}
                        </MenuItem>
                    )}
                </DropdownButton>
                <p style={{marginTop: "5px", marginBottom: "0px"}}>Selected delivery date:</p>
                <div className="review-date-picker">
                    <DatePicker
                        selected={this.props.selectedDeliveryDate}
                        includeDates={this.props.deliveryDates}
                        onChange={this.handleDateChange}
                        className="op-date-picker"
                        withPortal
                        ref={el => this.onDatepickerRef(el)}
                    />
                </div>
                <p style={{ display: "inline", color: "#fff" }}>{window.innerWidth.toString()}</p>
                <Checkbox checked={this.state.isShipComplete}
                    onChange={this.toggleShipComplete}
                    style={{marginTop: "12px", marginBottom: "15px"}}
                >
                    Ship Complete?
                </Checkbox><br />

                <p className="op-paragraph">Customer:<br className={this.state.mobileView === true || this.state.tabletView === true ? '' : 'hidden'} />
                    <span><b className="op-customer-review" style={this.state.mobileView === true || this.state.tabletView === true ? { marginLeft: '0px' } : {}}>[{localStorage.getItem('customer')}] {localStorage.getItem('addressName')}</b></span>
                </p>
                <p className="op-paragraph">Contact Person: <b>{localStorage.getItem('orderPlannerContactName')}</b></p>
                <p className="op-paragraph">Contact Email: <b>{localStorage.getItem('orderPlannerContactEmail')}</b></p>
                <p className="op-paragraph">Contact Phone: <b>{localStorage.getItem('orderPlannerContactPhone')}</b></p>
                <p className="op-paragraph">Purchase Order: <b>{localStorage.getItem('orderPO')}</b></p>

                <p className="op-paragraph">Delivery Address:<br />
                    <b>
                        [{localStorage.getItem('address')}] {localStorage.getItem('addressName')}<br />
                        {localStorage.getItem('street')}<br />
                        {localStorage.getItem('city')}, {localStorage.getItem('state')} {localStorage.getItem('zip')}
                    </b>
                </p>

                <p className="op-paragraph">Special Instructions:<br />
                    <b>{localStorage.getItem('specialInstructions')}</b>
                </p>

                <Button onClick={this.toggleShowDetails}>{this.state.showDetailsText}</Button>
                <h3>Order Data</h3>
                <OrderDataReview
                    orderItems={this.state.orderItems}
                    showDetails={this.state.showDetails}
                />

                <div style={this.state.mobileView === true || this.state.tabletView === true ? { width: '150px' } : { width: '150px', marginLeft: '682px' }}>
                    <span><b style={{ color: 'black' }}>Subtotal:</b></span>
                    <span style={{ float: 'right' }}><b>{this.state.orderSubtotal.toLocaleString(undefined, { minimumFractionDigits: 2 })}</b></span>
                    <br />

                    <span><b style={{ color: 'black' }}>Total Lines:</b></span>
                    <span style={{ float: 'right' }}><b>{this.state.orderLines}</b></span>
                    <br />

                    <span><b style={{ color: 'black' }}>Total Qty:</b></span>
                    <span style={{ float: 'right' }}><b>{this.state.orderQty}</b></span>
                    <br />

                    <div className={this.state.showDetails === true ? '' : 'hidden' }>
                        <b style={{ color: 'black' }}>Margin:</b>
                        <span style={{ float: 'right' }}><b>{((this.state.orderSubtotal - this.state.orderTotalCost) / this.state.orderSubtotal * 100).toFixed(0) + '%'}</b></span>
                    </div>
                </div>

                <br /><br />
                
                <div style={{ clear: 'both', marginBottom: '15px'}}>
                    <ResetOrderPlannerDataButton />
                    <Button style={{ marginLeft: '15px' }}
                        onClick={() => {
                            window.open('/order-planner-products', '_self');
                        }}>
                        &laquo; Previous
                    </Button>

                    <Button style={{ marginLeft: '15px' }}
                        bsStyle="success"
                        onClick={() => {
                        localStorage.setItem('orderPlannerReview', true);
                        window.open('/order-planner-submit', '_self');
                    }}>
                        Submit Order
                    </Button>
                </div>
            </div>
        );
    }
}

export default connect(
    state => state.orderPlannerDelivery,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(OrderPlannerReview);


// WEBPACK FOOTER //
// ./src/components/sales/OrderPlannerReview.js